<template>
  <fullscreen ref="fullscreen" @change="fullscreenChange">
    <div class="home">
      <left-panel-layout :is-left-panel-open="mapLoaded" class="app-layout">
        <template v-slot:left-panel>
          <div class="filtres">
            <!-- <div class="fitres__region">
              <h3>Région</h3>
              <select v-if="regionFile" v-model="selectedRegion">
                <option value="" selected hidden>Toutes les régions</option>
                <option v-for="option in regionFile" :key="option.id">
                  {{ option.region }}
                </option>
              </select>
            </div> -->
            <!-- <div class="filtres__categories">
              <h3>Catégories</h3>
              <div class="category">
                <switch-button
                  v-model="filters.rocqtr"
                  class="switch-button"
                  :background-color="'black'"
                />
                <div class="switch-label">Organisme membre du ROCQTR</div>
              </div>
              <div class="category">
                <switch-button
                  v-model="filters.attrueq"
                  class="switch-button"
                  :background-color="'black'"
                />
                <div class="switch-label">
                  Organisme avec des membre(s) de l'ATTRueQ
                </div>
              </div>
            </div> -->

            <div class="list">
              <div
                v-for="item in features"
                :key="item.properties.id"
                class="list__item"
                @click="selected = item"
              >
                {{ item.properties[`Nom de l'organisme`] }}
              </div>
            </div>
          </div>
        </template>
        <template v-slot:map>
          <Map
            v-if="dataReady"
            :locations-geojson="geoJSON"
            :extentvalues="extentvalues"
            :filters="filters"
            :selected="selected"
            @loaded="mapLoaded = true"
            @locationinfoselect="locationInfoSelect"
            @unselect="selected = null"
            @features="updateFeatures"
          />
        </template>
      </left-panel-layout>
      <panel v-if="selected" class="home__right-panel panel-lg-screen">
        <centers-infos :pointinfo="selected.properties" />
      </panel>
      <bottom-panel v-if="dataReady && selected" class="panel-sm-screen">
        <centers-infos :pointinfo="selected.properties" />
      </bottom-panel>
      <mailing-data-downloader
        v-if="!isProd && locations.length"
        style="position: absolute; top: 0; right: 50vw; margin: 36px"
        :json-data="locations"
      />
      <div
        class="full-screen-button"
        title="mode plein écran"
        @click="toggleFullscreen"
      >
        <i
          class="fa fa-2x"
          :class="fullscreen ? 'fa-compress' : 'fa-expand'"
        ></i>
      </div>
    </div>
  </fullscreen>
</template>

<script>
import Map from '@/components/map'
import { getcsvdata, toGeoJSON } from '@/data-loader'
import LeftPanelLayout from '@anagraph/left-panel-layout'
import Panel from '@anagraph/panel'
import regionfile from '../region-filter'
import CentersInfos from '@/components/centers-infos.vue'
import BottomPanel from '../components/layout/bottom-panel.vue'
// import SwitchButton from '../commons/components/Switch'
// import Fullscreen from 'vue-fullscreen'
import MailingDataDownloader from '@/components/MailingDataDownloader.vue'
export default {
  name: 'Home',
  components: {
    Map,
    LeftPanelLayout,
    Panel,
    CentersInfos,
    BottomPanel,
    // SwitchButton,
    MailingDataDownloader
  },
  data() {
    return {
      mapLoaded: false,
      dataReady: false,
      locations: [],
      geoJSON: null,
      regionFile: regionfile,
      selectedRegion: '',
      selected: null,
      extentvalues: { xmin: '', ymin: '', xmax: '', ymax: '' },
      filters: { rocqtr: false, cami: false, attrueq: false },
      fullscreen: false,
      features: [],
      isProd: process.env.NODE_ENV === 'production'
    }
  },
  watch: {
    selectedRegion(newVal) {
      this.regionFile
        .filter(i => i.region === newVal)
        .map(y => {
          this.extentvalues.xmin = y.xmin
          this.extentvalues.ymin = y.ymin
          this.extentvalues.xmax = y.xmax
          this.extentvalues.ymax = y.ymax
        })
    }
  },
  async mounted() {
    const url = this.isProd
      ? process.env.BASE_URL + 'data.csv'
      : process.env.VUE_APP_CSV_DATA_URL
    this.locations = await getcsvdata(url)
    this.geoJSON = toGeoJSON(this.locations, {
      Point: ['Latitude', 'Longitude']
    })
    this.dataReady = true
  },
  methods: {
    locationInfoSelect({ locinfo }) {
      this.selected = locinfo
    },
    toggleFullscreen() {
      this.$refs.fullscreen.toggle()
    },
    fullscreenChange(fullscreen) {
      this.fullscreen = fullscreen
    },
    updateFeatures(features) {
      this.features = features
    }
  }
}
</script>
<style lang="scss">
.home {
  .full-screen-button {
    cursor: pointer;
    position: absolute;
    top: 12px;
    right: 12px;
    // padding: 4px 2px 3px 4px;
    // background: white;
    // box-shadow: 0 0 10px 2px rgba(0, 0, 0, 0.1);
  }
  .left-panel {
    &__panel[data-v-2807172c] {
      min-height: 178px;
    }
    .list {
      max-height: 600px;
      overflow-y: auto;
      padding: 0 12px;
      &__item {
        display: flex;
        align-items: center;
        justify-content: left;
        background-color: #eee;
        margin-bottom: 10px;
        padding: 0 12px;
        height: 100px;
        border-radius: 4px;
        font-weight: 700;
        cursor: pointer;

        &:first-child {
          margin-top: 20px;
        }

        &:hover {
          background-color: #ddd;
        }
      }
    }
    @media (max-width: 1023px) {
      display: none;
    }
  }
  .sm-filtre-panel {
    position: absolute;
    min-height: initial;
    width: 300px;
    height: 48px;
    top: 20px;
    margin-left: auto;
    margin-right: auto;
    left: 0;
    right: 0;
    text-align: center;
    @media (min-width: 1024px) {
      display: none;
    }
    border-radius: 8px;
    select {
      -moz-appearance: none;
      -webkit-appearance: none;
      appearance: none;
      position: relative;
      margin: 13px 24px;
      border: none;
    }
    // &__box {
    //   margin: auto;
    // }
  }
  .filtres {
    padding: 24px;
    &__categories {
      margin-top: 48px;
      .category {
        display: flex;
        padding: 4px 0;
        .switch-label {
          padding: 0 16px;
        }
      }
    }
  }
  &__right-panel {
    position: absolute !important;
    width: 400px;
    background-color: white;
    z-index: 500;
    top: 100px;
    right: 50px;
  }
}
.panel-lg-screen {
  @media (max-width: 1023px) {
    display: none;
  }
}
.panel-sm-screen {
  @media (min-width: 1024px) {
    display: none;
  }
}
</style>
